import { Alert, Typography } from "@mui/material";
import { TableData, TableDataProps } from "../TableData";

export const BeroepsI1b1April14 = (props: TableDataProps) => {
  return (
    <>
      <TableData data={props.data} />

      <Alert severity="info" sx={{ alignItems: "center" }}>
        <Typography variant="h5">
          3e lesuur - 13:00 tot 14:00 - opleveren 🏆
        </Typography>
      </Alert>

      <Alert severity="error" sx={{ mb: 2, alignItems: "center" }}>
        <Typography variant="h5">
          4e lesuur - 14:00 tot 15:00 - werken aan werkprocessen - uiterlijk
          dinsdag om 00:00 inleveren in Teams 📄
        </Typography>
      </Alert>
    </>
  );
};
